import teacher from './teacher/index';
import uGear from './u-gear/index';

export default {
  path: '/learning-center',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: '',
      redirect: 'index',
    },
    {
      path: 'index',
      component: resolve => require(['@/components/learning-center/Index'], resolve),
    },
    {
      path: 'card-records',
      component: resolve => require(['@/components/learning-center/CardRecords'], resolve),
    },
    {
      path: 'sign-up-code',
      component: resolve => require(['@/components/learning-center/SignUpCode'], resolve),
    },
    {
      path: 'learning-center-detail',
      component: resolve => require(['@/components/learning-center/LearningCenterDetail'], resolve),
    },
    {
      path: 'set-admissions-wechat',
      component: resolve => require(['@/components/learning-center/SetAdmissionsWechat'], resolve),
    },
    {
      path: 'set-address/:schoolId',
      component: resolve => require(['@/components/learning-center/SetAddress'], resolve),
    },
    {
      path: 'learn-cards',
      component: resolve => require(['@/components/learning-center/LearnCards'], resolve),
    },
    ...teacher,
    ...uGear,
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/learning-center/index.js